import type { CapabilityDimension } from "./blueprintTypes";

export interface DimensionFieldChange {
  label: string;
  oldValue: string;
  newValue: string;
}

export interface DimensionDiff {
  name: string;
  added: boolean;
  removed: boolean;
  fieldChanges: DimensionFieldChange[];
}

const DIMENSION_FIELDS: { key: keyof CapabilityDimension; label: string }[] = [
  { key: "description", label: "Description" },
  { key: "idealScore", label: "Ideal Score" },
  { key: "positiveIndicators", label: "Positive Indicators" },
  { key: "negativeIndicators", label: "Negative Indicators" },
];

export function computeCapabilityDimensionsDiff(
  oldDimensions: CapabilityDimension[],
  newDimensions: CapabilityDimension[],
): DimensionDiff[] {
  const oldByName = new Map(oldDimensions.map((d) => [d.name, d]));
  const newByName = new Map(newDimensions.map((d) => [d.name, d]));
  const diffs: DimensionDiff[] = [];

  for (const dim of oldDimensions) {
    if (!newByName.has(dim.name)) {
      diffs.push({ name: dim.name, added: false, removed: true, fieldChanges: [] });
    }
  }

  for (const dim of newDimensions) {
    const oldDim = oldByName.get(dim.name);
    if (!oldDim) {
      diffs.push({ name: dim.name, added: true, removed: false, fieldChanges: [] });
      continue;
    }

    const fieldChanges: DimensionFieldChange[] = [];
    for (const { key, label } of DIMENSION_FIELDS) {
      const oldVal = String(oldDim[key] ?? "");
      const newVal = String(dim[key] ?? "");
      if (oldVal !== newVal) {
        fieldChanges.push({ label, oldValue: oldVal, newValue: newVal });
      }
    }
    if (fieldChanges.length > 0) {
      diffs.push({ name: dim.name, added: false, removed: false, fieldChanges });
    }
  }

  return diffs;
}
